



































































import { branchDrafts } from '@/store/interfaces/drafts';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class BankAccountInboundForm extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  branch!: branchDrafts;

  active = false;

  branchToUpdate: branchDrafts = {
    id: '',
    name: '',
    address: '',
    phone: '',
    contact_phone: '',
    contact_name: '',
  };

  @Watch('branch', { deep: true, })
  onBranchToUpdateChange(br: branchDrafts): void {
    this.branchToUpdate = br;
  }

  updateInboundBranch(): void {
    this.$emit('update', this.branchToUpdate);
  }
}
